<template>
    <div class="vue-active-country-teasers" v-if="hasActivities">
        <div class="title">
            <h2>{{ activeTeaserTitle }} {{ selectedCountry.name }}</h2>
        </div>

        <div class="wrapper">
            <div class="teaser" v-for="activity in activities" @click="handleTeaserClick(activity.url)">
                <div class="layout-teaser">
                    <div class="image-wrapper">
                        <img :src="activity.image" :alt="activity.name" class="teaser-image">
                    </div>

                    <div class="content-wrapper">
                        <p class="subtitle">{{ activity.tag }}</p>

                        <h3 class="virtual-h4"><a :href="activity.url"></a>{{ activity.name }}</h3>

                        <p class="read-more mb-0">{{ readMore }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ActiveCountryTeasers",

    props: ['selectedCountry', 'readMore', 'activeTeaserTitle'],

    computed: {
        hasActivities() {
            return !_.isEmpty(this.activities)
        },

        activities() {
            return this.selectedCountry.activities;
        }
    },

    methods: {
        handleTeaserClick(url) {
            window.open(url, '_self');
        }
    }
}
</script>